import baseAPI from "@/http";

const router = "api/consulta-avancada";

export const advancedQueryAPI = {
  listSchemas: () => baseAPI.get(`${router}/schemas`),
  listTables: (schemas, search) =>
    baseAPI.get(`${router}/tables`, { params: { schemas, search } }),
  listColumns: (schema, table) => baseAPI.get(`${router}/columns`, { params: { schema, table } }),
  listSavedQueries: () => baseAPI.get(`${router}/saved`),
  saveQuery: (payload) => baseAPI.post(`${router}/saved`, payload),
  runQuery: (payload) => baseAPI.post(`${router}/run`, payload),
  validateQuery: (payload) => baseAPI.post(`${router}/validate`, payload),
  deleteSavedQuery: (id) => baseAPI.delete(`${router}/saved/${id}`),
};
